//import { useState } from "react";
import { useState } from 'react';
import NewPasswordForm from './NewPasswordForm';
import Background from '../../../assets/Images/png/bg-new-password.svg';
import SuccessForm from './SuccessForm';

const NewPassword = ({ history }) => {
    const [currentPageAction, setCurrentPageAction] = useState({
        name: 'FORGOT',
        mail: '',
        text: '',
    });
    return (
        <div
            className="h-screen w-full bg-cover bg-fixed bg-no-repeat bg-center relative"
            style={{
                backgroundImage: `url(${Background})`,
            }}
        >
            <div className="flex justify-center items-center w-full h-screen">
                <div className="w-sm m-auto rounded-lg pb-12">
                    {currentPageAction.name === 'FORGOT' ? (
                        <NewPasswordForm
                            history={history}
                            currentPageAction={currentPageAction}
                            setCurrentPageAction={setCurrentPageAction}
                        />
                    ) : (
                        <SuccessForm
                            currentPageAction={currentPageAction}
                            setCurrentPageAction={setCurrentPageAction}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewPassword;
